import axios from "axios";
import { decryptAEStoString, toastEmitter } from "../utills/utilities";
import { API_URL } from "./url-constant";
import { store } from "../admin/hooks/redux/store";

const axioUser = axios.create({
    baseURL: `${API_URL.baseURL}`,

});
axioUser.interceptors.request.use(
    (config) => {
        let state = store.getState(),
            UserRawAccessToken = state?.employeeAccessToken?.value;
        UserRawAccessToken = UserRawAccessToken
            ? (UserRawAccessToken)
            : UserRawAccessToken;
        if (UserRawAccessToken) {
            config.headers.Authorization = `Bearer ${UserRawAccessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
axioUser.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            return toastEmitter("error", "Session expired, Please login again!");
        }

        return error.response;
    }
);


export default axioUser
